import { Box, Typography } from '@mui/material';

export const parseConflictMessage = (message = '') => {
  const lines = message.split('\n').filter((line) => line.trim() !== '');
  const content = [];
  let currentList = [];

  lines.forEach((line, index) => {
    const trimmed = line.trim();
    if (trimmed.startsWith('•')) {
      currentList.push(trimmed.replace(/^•\s*/, ''));
    } else {
      // Push previous list if exists
      if (currentList.length) {
        content.push(
          <ul key={`list-${index}`} style={{ paddingLeft: 20, margin: '4px 0' }}>
            {currentList.map((item, idx) => (
              <li key={idx}>
                <Typography variant="body2">{item}</Typography>
              </li>
            ))}
          </ul>,
        );
        currentList = [];
      }

      content.push(
        <Typography key={`text-${index}`} variant="body2" gutterBottom>
          {trimmed}
        </Typography>,
      );
    }
  });

  if (currentList.length) {
    content.push(
      <ul key={'list-last'} style={{ paddingLeft: 20, margin: '4px 0' }}>
        {currentList.map((item, idx) => (
          <li key={idx}>
            <Typography variant="body2">{item}</Typography>
          </li>
        ))}
      </ul>,
    );
  }

  return <Box>{content}</Box>;
};
